var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66675 5.33333H4.33341V13.3333H11.6667V5.33333H11.3334H4.66675ZM13.0001 5.33333V13.3333H13.3334C13.7016 13.3333 14.0001 13.0349 14.0001 12.6667V6C14.0001 5.63181 13.7016 5.33333 13.3334 5.33333H13.0001ZM2.66675 5.33333H3.00008V13.3333H2.66675C2.29856 13.3333 2.00008 13.0349 2.00008 12.6667V6C2.00008 5.63181 2.29856 5.33333 2.66675 5.33333ZM11.3334 4L13.3334 4C14.438 4 15.3334 4.89543 15.3334 6V12.6667C15.3334 13.7712 14.438 14.6667 13.3334 14.6667H2.66675C1.56218 14.6667 0.666748 13.7712 0.666748 12.6667V6C0.666748 4.89543 1.56218 4 2.66675 4L4.66675 4C4.66675 2.89543 5.56218 2 6.66675 2H9.33341C10.438 2 11.3334 2.89543 11.3334 4ZM10.0001 4C10.0001 3.63181 9.7016 3.33333 9.33341 3.33333H6.66675C6.29856 3.33333 6.00008 3.63181 6.00008 4H10.0001Z",
    fill: "#002760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.7914d2cb147c85915068f7de97c49e6c.svg";
export { ForwardRef as ReactComponent };